import { db } from '@react-native-firebase/database';
import { getLocalStorageItem } from 'core/helpers';
import { onChildAdded, ref, update } from 'firebase/database';
import React, { createContext, useEffect, useState } from 'react';
import { isAdminUser } from 'src/utils/UserUtils';

interface TimeOffRequest {
    availability: string;
    endDate: string;
    name: string;
    reason: string;
    rejectReason: string;
    startDate: string;
    status: string;
    isViewedByAdmin: boolean;
}

interface NotificationContextType {
    timeOffRequest: TimeOffRequest | null;
    setTimeOffRequest: React.Dispatch<React.SetStateAction<TimeOffRequest | null>>;
    message: any; // Adjust this type as per your requirement
    setMessage: React.Dispatch<React.SetStateAction<any>>;
    notificationClicked: boolean,
    setNotificationClicked: React.Dispatch<React.SetStateAction<boolean>>;
    messageCount: number;
    setMessageCount: React.Dispatch<React.SetStateAction<number>>;
}

export const NotificationContext = createContext<NotificationContextType>({
    timeOffRequest: null,
    setTimeOffRequest: () => { },
    message: null,
    setMessage: () => { },
    notificationClicked: false,
    setNotificationClicked: () => { },
    messageCount: 0,
    setMessageCount: () => { },

});

export const NotificationProvider = ({ children }: { children: any }) => {
    const [timeOffRequest, setTimeOffRequest] = useState<TimeOffRequest | null>(null);
    const [message, setMessage] = useState<any>(null);
    const loggedinUser = getLocalStorageItem("loggedinUser");
    const [notificationClicked, setNotificationClicked] = useState(false);
    const [messageCount, setMessageCount] = useState(0);


    useEffect(() => {
        if (loggedinUser) {
            const isUserAdmin = isAdminUser(loggedinUser?.stsTokenManager);
            const timeOffRequestRef = ref(db, 'timeOffRequest');

            const onUserAdded = onChildAdded(timeOffRequestRef, (snapshot) => {
                const userId = snapshot.key;

                const userRef = ref(db, `timeOffRequest/${userId}`);

                const onDateAdded = onChildAdded(userRef, (dateSnapshot) => {
                    const date = dateSnapshot.key;

                    const dateRef = ref(db, `timeOffRequest/${userId}/${date}`);

                    const onRequestAdded = onChildAdded(dateRef, async (requestSnapshot) => {
                        const requestDataId = requestSnapshot.key;
                        const requestData = requestSnapshot.val();

                        if (!requestData.isViewedByAdmin && isUserAdmin) {
                            setTimeOffRequest(requestData);
                            try {
                                const requestRef = ref(db, `timeOffRequest/${userId}/${date}/${requestDataId}`);
                                await update(requestRef, { isViewedByAdmin: true });
                            } catch (error) {
                                console.error('Error updating isViewedByAdmin flag:', error);
                            }
                        }
                    });

                    return () => {
                        onRequestAdded();
                    };
                });

                return () => {
                    onDateAdded();
                };
            });

            return () => {
                onUserAdded();
            };
        }
    }, []);

    useEffect(() => {
        if (loggedinUser) {
            const messagesRef = ref(db, 'messages');

            const onUserAdded = onChildAdded(messagesRef, (snapshot) => {
                const conversationId: any = snapshot.key;

                const userRef = ref(db, `messages/${conversationId}`);

                const onDateAdded = onChildAdded(userRef, (dateSnapshot) => {
                    const date = dateSnapshot.key;

                    const dateRef = ref(db, `messages/${conversationId}/${date}`);

                    const onMessageAdded = onChildAdded(dateRef, async (requestSnapshot) => {
                        const requestDataId = requestSnapshot.key;
                        const requestData = requestSnapshot.val();
                        if (requestData.receiverId === loggedinUser.uid && !requestData.isViewed) {
                            setMessage(requestData);
                            setMessageCount(prevCount => prevCount + 1);
                            try {
                                const requestRef = ref(db, `messages/${conversationId}/${date}/${requestDataId}`);
                                console.log('messages', requestRef);
                                await update(requestRef, { isViewed: true });
                            } catch (error) {
                                console.error('Error updating isViewed flag:', error);
                            }
                        }
                    });

                    return () => {
                        // Clean up the request listener
                        onMessageAdded();
                    };
                });

                return () => {
                    // Clean up the date listener
                    onDateAdded();
                };
            });

            return () => {
                // Clean up the user listener
                onUserAdded();
            };
        }
    }, []);

    return (
        <NotificationContext.Provider value={{ timeOffRequest, setTimeOffRequest, message, setMessage, notificationClicked, setNotificationClicked ,messageCount, setMessageCount}}>
            {children}
        </NotificationContext.Provider>
    );
};
